<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Lista de Costo por Proyectos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-if="enabledExcel" @click="exportaExcel()" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <k-table
      :filterStatus="filterStatus"
      :editButton="false"
      :deleteButton="false"
      :createButton="false"
      :fechas="true"
      ref="listaCostoProyectos"
      @seleccionar="seleccionar"
      :path="url + '/costos-proyectos'"
      :columns="[
        {
          display: 'Proyecto',
          value: 'nombre_proyecto'
        },
        {
          display: 'Fecha',
          value: 'fecha'
        },
        {
          display: 'Descripción',
          value: 'descripcion'
        },
        {
          display: 'Valor',
          value: 'valor',
          prefijo: '$',
        },
        {
          display: 'Observacion',
          value: 'observacion'
        },
        {
          display: 'Estado',
          value: 'nombre_estado'
        },
        {
          display: 'Fecha de creación',
          value: 'created_at'
        },
        {
          display: 'Fecha de modificación',
          value: 'updated_at'
        }
      ]"
    ></k-table>
  </div>
</template>
<script>
export default {
  props: {
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    enabledExcel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      currentIndex: -1,
      url: url
    }
  },
  methods: {
    exportaExcel: function(){
      window.open(url + '/costos-proyectos?exportar=S', '_blank');
    },
    seleccionar: function(current){
      this.$emit("selected", current);
      this.$modal.hide('modalListaCostoProyectos');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/ListaCostoProyectos.vue